import React, { lazy, Suspense } from 'react';
import { Box, Dialog, LinearProgress, Typography } from '@mui/material';
import closingRobot from '../assets/closingRobot.json';

const Lottie = lazy(() => import('lottie-react'));

interface ProcessingOrderModalProps {
	open: boolean;
}

export default function ProcessingOrderModal({
	open,
}: ProcessingOrderModalProps) {
	return (
		<Dialog
			open={open}
			maxWidth="xs"
			fullWidth
			disableEscapeKeyDown
			PaperProps={{
				sx: {
					borderRadius: '24px',
					background:
						'linear-gradient(180deg, rgba(17, 20, 31, 0.98) 0%, rgba(11, 14, 23, 0.98) 100%)',
					border: '1px solid var(--atlas-border-accent, rgba(255,255,255,0.12))',
					boxShadow: '0 24px 80px rgba(0, 0, 0, 0.45)',
					overflow: 'hidden',
				},
			}}
		>
			<Box
				sx={{
					px: { xs: 3, sm: 4 },
					py: { xs: 4, sm: 4.5 },
					textAlign: 'center',
				}}
			>
				<Box
					sx={{
						width: { xs: 180, sm: 220 },
						height: { xs: 180, sm: 220 },
						mx: 'auto',
						mb: 2,
					}}
				>
					<Suspense
						fallback={
							<Box
								width="100%"
								height="100%"
								display="flex"
								alignItems="center"
								justifyContent="center"
							>
								<LinearProgress sx={{ width: '60%' }} />
							</Box>
						}
					>
						<Lottie
							animationData={closingRobot}
							loop
							autoplay
							style={{ width: '100%', height: '100%' }}
						/>
					</Suspense>
				</Box>

				<Typography
					fontFamily="Oxanium"
					sx={{
						fontSize: { xs: '18px', sm: '20px' },
						fontWeight: 600,
						lineHeight: 1.5,
						color: 'var(--atlas-text-primary, #fff)',
						maxWidth: '280px',
						mx: 'auto',
					}}
				>
					Order processing in progress...
				</Typography>
			</Box>
		</Dialog>
	);
}
